// couponReservationService.js
// Serviço frontend para o fluxo de CouponReservation (reservas do fluxo de checkout).
// Espelha o padrão de couponService.js e couponUserService.js.

import api from "./api";

/**
 * Busca reservas de cupom de forma paginada com filtros opcionais.
 *
 * @param {number} pageNumber
 * @param {number} pageSize
 * @param {object} filters
 *   - couponId           {string} – substring numérica sobre coupon_id
 *   - userId             {string} – igualdade exata sobre user_id
 *   - subscriptionId     {string} – substring numérica sobre subscription_id (nullable)
 *   - couponCode         {string} – substring textual (LIKE) em coupons.code
 *   - userName           {string} – substring textual (LIKE) em users.user_name
 *   - reservationStatus  {string} – "active" | "consumed" | "cancelled" | "expired" | ""
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function fetchCouponReservationsPaged(
  pageNumber,
  pageSize,
  filters = {},
) {
  const params = { pageNumber, pageSize };

  if (filters.couponId?.trim()) {
    params.couponId = filters.couponId.trim();
  }
  if (filters.userId?.trim()) {
    params.userId = filters.userId.trim();
  }
  if (filters.subscriptionId?.trim()) {
    params.subscriptionId = filters.subscriptionId.trim();
  }
  if (filters.couponCode?.trim()) {
    params.couponCode = filters.couponCode.trim();
  }
  if (filters.userName?.trim()) {
    params.userName = filters.userName.trim();
  }
  if (filters.reservationStatus?.trim()) {
    params.reservationStatus = filters.reservationStatus.trim();
  }

  return api.get("/CouponReservations/paged", { params });
}

/**
 * Busca uma reserva pelo seu ID.
 * @param {number} id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function getCouponReservationById(id) {
  return api.get(`/CouponReservations/${id}`);
}

/**
 * Cria uma nova reserva manual (somente Sys).
 *
 * ⚠️ Em fluxo normal, reservas são criadas automaticamente pelo SubscriptionsService
 *    durante o checkout. Esta rota existe apenas para ajustes administrativos.
 *
 * @param {object} data - { couponId, userId, subscriptionId?, expiresAt }
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function createCouponReservation(data) {
  return api.post("/CouponReservations", data);
}

/**
 * Atualiza uma reserva existente (somente Sys).
 * @param {object} data - { couponReservationId, expiresAt, subscriptionId?, consumedAt?, cancelledAt? }
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function updateCouponReservation(data) {
  return api.put(`/CouponReservations/${data.couponReservationId}`, data);
}

/**
 * Exclui uma reserva pelo seu ID.
 * @param {number} id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function deleteCouponReservation(id) {
  return api.delete(`/CouponReservations/${id}`);
}

/**
 * Exclui múltiplas reservas em lote.
 * Backend: DELETE /api/CouponReservations/batch
 *
 * @param {number[]} ids
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function deleteCouponReservationsBatch(ids) {
  return api.delete("/CouponReservations/batch", { data: ids });
}
